import React, { useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { Helmet } from 'react-helmet-async';
import * as S from "./HomePage.styles";
import loadable from '@loadable/component';
import { tripTypeSelector, metaDataSelector, oneWayCabSelector, savaariBannerSelector } from "../../common/redux/selector";
import { gcHomeScreen, getLoadedComponent, pushCtaOmniEvents } from "../../config/omni";
import { scrollToTop } from "../../config/utils";
import { DEFAULT_H1_TAG } from "../../config/constants";
import { CTA_TYPE, getActionNameForOmniture } from "../../utils/omni-utils";
import { CABS_HOME_PAGE, CABS_LANDING_ROUTE, EXPLORE_MORE, OW, RT } from "../../utils/util-constants";
import { getTravellerInformation } from "./redux/thunks";
import SavaariBanner from "../../components/SavaariBanner";
import { getPokusDetails } from "../../common/redux/thunks";
import { UPDATE_UNIFICATION_FLOW } from "dweb-cars/shared/common/redux/action-types";

const HomeBanner = loadable(() => import(/* webpackChunkName: "Homebanner" */ '../Homepage/components/HomeBanner/Homebanner'));
const HomeFooter = loadable(() => import(/* webpackChunkName: "HomeFooter" */ '../Homepage/components/HomeFooter/HomeFooter'));
const HomeSearchWidget = loadable(() => import(/* webpackChunkName: "HomeSearchWidget" */ './containers/HomeSearchWidget/HomeSearchWidget'));
const NavigationDownCircle = loadable(() => import(/* webpackChunkName: "NavigationDownCircle" */ '../../../stories/assets/cars/NavigationDownCircle/NavigationDownCircle'));

const HomePage: React.FC = () => {
  const tripType = useSelector(tripTypeSelector);
  const isOneWayCab = useSelector(oneWayCabSelector);
  const savaariBannerInfo = useSelector(savaariBannerSelector);
  const dispatch = useDispatch()
  const exploreMoreClickHandler = () => {
    pushCtaOmniEvents(getActionNameForOmniture(gcHomeScreen, EXPLORE_MORE), CTA_TYPE.BUTTON, CABS_HOME_PAGE, CABS_LANDING_ROUTE)
    window?.scrollTo({ behavior: "smooth", top: 650 });
  };
  const { desktop = {} } = useSelector(metaDataSelector);
  const { outstation = {}, airport = {}, rental = {}, oneway = {} } = desktop;
  const metaData = tripType?.rf === 'at' ? airport : (tripType?.rf === 'hr' ? rental : (isOneWayCab ? oneway : outstation));
  const { title = "", meta = [], link = [], h1 = DEFAULT_H1_TAG } = metaData;

  useEffect(() => {
    getLoadedComponent('Home Page')
    dispatch(getTravellerInformation())
    scrollToTop(0)
    pokusDetails()
  }, [])

  const pokusDetails = async () => {
    const response = await getPokusDetails()
    if (response?.unification_web) {
      dispatch({
        type: UPDATE_UNIFICATION_FLOW,
        isUnificationFlow: response?.unification_web
      })
    }
  }

  return (
    <S.HomePageWrapper>
      <Helmet title={title} meta={meta} link={link} />
      <S.PageBackground></S.PageBackground>
      <S.PageContentWrapper>
        <S.PageHeader>{h1}</S.PageHeader>
        {/* search widget wrap */}
        <S.SearchBlock>
          <HomeSearchWidget />
          <S.OfferBlock>
            <HomeBanner />
          </S.OfferBlock>
        </S.SearchBlock>
       {/* {tripType?.rf === OW || tripType?.rf === RT ? 
        <SavaariBanner data={savaariBannerInfo}/> : null} */}
        <S.ExploreBtn>
          <S.ExploreMoreBtn onClick={exploreMoreClickHandler}>
            <S.ExploreBtnText>Explore More </S.ExploreBtnText>
            <NavigationDownCircle />
          </S.ExploreMoreBtn>
        </S.ExploreBtn>
        <HomeFooter />
      </S.PageContentWrapper>
    </S.HomePageWrapper>
  );
};

export default React.memo(HomePage);
